module.exports = __webpack_public_path__ + "static/media/brum.631abf05.png";